

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const parentMenuAtom = atom({key:'parentMenuAtom', default:{
menu_parent_info:[], module_info:[]
}});


const parentMenuEditAtom = atom({key:'parentMenuEditAtom', default:{}});





export  const SetParentMenu = () => useSetRecoilState(parentMenuAtom);
export  const GetParentMenu = () => useRecoilValue(parentMenuAtom);



export  const SetParentMenuEdit = () => useSetRecoilState(parentMenuEditAtom);
export  const GetParentMenuEdit = () => useRecoilValue(parentMenuEditAtom);









